import { request } from "../../utils/config"

export const UPDATE_USER_MUSIC = async (data) => {
  const response = await request({
    url: `Users/UpdateUserMusic`,
    method: "PUT",
    // Boshliq (2026-09-05): server `UpdateUserMusic(int musicID)` qiymatni QUERY'dan o'qiydi — body yuborilgani uchun 0 saqlanib,
    // keyingi kirishda Telegram Chime qaytib kelardi. Endi query orqali.
    params: { musicID: Number(data?.musicID ?? data?.musicId ?? 0) },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
